<!--审核医生任务列表-->
<template>
	<div>
		<el-table class="qcTable" :data="TaskListArrData.SamplingTasks" v-loading="loading">
			<el-table-column prop="Id" label="任务编号" min-width="100"></el-table-column>
			<el-table-column prop="Name" label="名称"></el-table-column>
			<el-table-column prop="CategoryName" min-width='90' label="抽样类型">
				<template slot-scope="scope">
					<span v-if="scope.row.CategoryName=='影像'" title="影像">影像</span>
					<span v-else-if="scope.row.CategoryName=='报告'" title="报告">报告</span>
					<span v-else title="影像和报告">影像和报告</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="Progress" label="质控进度" v-if="statusList == 20">
				<template slot-scope="scope">
					<el-tooltip effect="dark" placement="top-start">
						<div class="progress">
							<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.CompleteCount/scope.row.SampledCount)*100)}%`">
							</div>
							<span class="sr-only">{{(Math.floor((scope.row.CompleteCount/scope.row.SampledCount)*100))}}%</span>
						</div>
						<div slot="content" class="tableTooltip">
							<div>
								<em></em>
								<span>已完成数量:{{scope.row.CompleteCount}}</span>
							</div>
						</div>
					</el-tooltip>
				</template>
			</el-table-column> -->
			<el-table-column prop="SampledCount" label="总数"></el-table-column>
			<el-table-column prop="CreateDt" min-width="100" :formatter="formattertime" label="创建时间"></el-table-column>
			<el-table-column prop="ComepleteDt" min-width="100" :formatter="formattertime" label="完成时间"></el-table-column>
			<el-table-column prop="CreateorName" label="创建人"></el-table-column>
			<el-table-column prop="" label="操作" width="180">
				<template slot-scope="scope">
					<span class="tableOpe" @click="experClick(scope.row)">查看报告</span>
				</template>
			</el-table-column>
		</el-table>

	</div>
</template>
<style scoped>
	.el-form-item {
		margin-bottom: 10px !important;
	}
</style>
<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				filtersz: [],
				recordExpands: '',
				expands: [],
				radio: ''
			}
		},
		computed: {
			...Vuex.mapState('doctor', ['getReporterReportListArr', 'TaskListArrData', 'total', 'taskListTitle', 'samplingTaskGuid']),
			...Vuex.mapState('breadcrumb', ['loading'])
		},
		activated() {
			this.init();
		},
		created(){
			this.init();
		},
		methods: {
			...Vuex.mapMutations('breadcrumb',['setTootipType','clearRow']),
			...Vuex.mapMutations('doctor', ['setDoctorType','setLoading', 'setDetailsParameter', 'taskListShowMu', 'setIsSubmint',
				'doctorDoctorStatus', 'setSplitScreen', 'exportDoctorStatusMu', 'isRole','setisSubmintflag'
			]),
			...Vuex.mapActions('doctor', ['GetTaskList','GetReportDetail', 'GetReporterReportList']),
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}

			},
			init(){
				this.setLoading(true);
				let userName = JSON.parse(localStorage.getItem('user'));
				if(userName.roleName == '审核医生') {
					this.taskListShowMu(false);
					this.doctorDoctorStatus("50")
					this.setDoctorType(1)
					this.setIsSubmint(true);
					this.setisSubmintflag(true);
				}
				if(userName.roleName == '技师') {
					this.taskListShowMu(false);
					this.doctorDoctorStatus("50")
					this.setDoctorType(2)
					this.setIsSubmint(true);
					this.setisSubmintflag(true);
				}
				this.GetTaskList();
			},
			experClick(row) {
				this.setLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.taskListTitle.name = row.Name;
				this.taskListTitle.type = 4;
				this.taskListTitle.categoryName = row.CategoryName;
				this.samplingTaskGuid.id = row.SamplingTaskGuid;
				this.getReporterReportListArr.isUnqualified = false;
				this.getReporterReportListArr.scoreItem = null;
				//this.taskListShowMu(true);
				this.isRole('doctor')
				this.$router.push("/home/doctor/doctorTable");
			}

		}

	}
</script>
